import React from "react";
import Carousel from "react-grid-carousel";
import line from "../../assets/icons/line-arrow.svg";

interface ResponsiveLayout {
  breakpoint: number;
  cols: number;
  rows: number;
}

interface CarouselSliderProps extends React.AllHTMLAttributes<HTMLDivElement> {
  cols: number;
  rows: number;
  gap?: number;
  autoPlays?: number;
  classRight?: string;
  classLeft?: string;
  imageRight?: string;
  imageLeft?: string;
  hideArrow?: boolean;
  children: React.ReactNode;
  responsiveLayout?: ResponsiveLayout[];
  className?: string;
  styleCaroussel?: {};
}

const CarouselSlider = ({
  cols,
  rows,
  gap,
  autoPlays,
  classRight,
  classLeft,
  imageRight,
  imageLeft,
  hideArrow,
  children,
  responsiveLayout,
  styleCaroussel,
}: CarouselSliderProps) => {
  return (
    <Carousel
      cols={cols}
      rows={rows}
      gap={gap}
      autoplay={autoPlays}
      loop
      containerStyle={styleCaroussel}
      hideArrow={hideArrow}
      responsiveLayout={responsiveLayout}
      arrowLeft={
        <>
          <div className={classLeft}>
            <img src={imageLeft} alt='arrow-left' />
          </div>
          <img className='takaful--news-line-middle' src={line} alt='line' />
        </>
      }
      arrowRight={
        <div className={classRight}>
          <img src={imageRight} alt='arrow-right' />
        </div>
      }>
      {React.Children.map(children, (child, index) => (
        <Carousel.Item key={index}>{child}</Carousel.Item>
      ))}
    </Carousel>
  );
};

export default CarouselSlider;
